/* eslint-disable jsx-a11y/control-has-associated-label */
import { useEffect, useState } from 'react';
import {
  CardHeader,
  Row,
  Col,
  Card,
  CardBody,
  Table,
  Button,
  Input,
  Modal,
  FormGroup,
  InputGroupAddon,
  InputGroup,
  InputGroupText,
  ModalBody,
  ModalFooter,
  Form,
  Container,
} from 'reactstrap';
import api from 'services/api';
import Swal from 'sweetalert2';
import { FaEdit, FaPlusCircle, FaTrash } from 'react-icons/fa';
import { CircularProgress } from '@material-ui/core';
import toast from 'react-hot-toast';
import { RegraPerdaEspecificaItem } from 'models/RegraPerdaEspecificaItem';
import UserSmallHeader from 'components/Headers/UserSmallHeader';
import AutocompleteItem, {
  iAutoCompleteItem,
} from 'components/AutocompleteItem';
import Header from 'components/Headers/Header';
import { Th, Td } from './styles';

interface iAtividade {
  id: number;
  codigo: string;
  descricao: string;
}

interface iEditing extends iAtividade {
  isNew: boolean | true;
}

export default function ConfiguradorAtividade(): JSX.Element {
  const [registros, setRegistros] = useState<iAtividade[]>([]);

  const [loading, setLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [registroEdicao, setRegistroEdicao] = useState<iEditing>(
    {} as iEditing,
  );

  async function buscarDados(): Promise<void> {
    try {
      setLoading(true);
      const response = await api.get(`/atividades`);
      const lista = response.data;
      setRegistros(lista);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    buscarDados();
  }, []);

  async function handleOpenModal() {
    setIsModalOpen(true);
    setRegistroEdicao({
      isNew: true,
      id: 0,
      codigo: '',
      descricao: '',
    });
    setIsEditing(false);
  }

  async function salvar() {
    const { codigo, descricao } = registroEdicao;

    if (!codigo && !descricao) {
      toast.error('Código e Descrição devem ser informados!');
      return;
    }

    const data = {
      codigo,
      descricao,
    };

    try {
      setIsSaving(true);

      if (isEditing) await api.put(`/atividades/${registroEdicao.id}`, data);
      else await api.post(`/atividades`, data);

      await buscarDados();

      setIsModalOpen(false);
      setRegistroEdicao({
        isNew: true,
        id: 0,
        codigo: '',
        descricao: '',
      });
    } finally {
      setIsSaving(false);
    }
  }

  async function handleEdit(registro: iAtividade) {
    setIsEditing(true);
    setIsModalOpen(true);

    setRegistroEdicao({
      ...registro,
      isNew: false,
    });
  }

  async function handleDelete(registro: iAtividade) {
    const resposta = await Swal.fire({
      title: `Deseja excluir o registro?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `Sim, excluir`,
      confirmButtonColor: '#d33',
      cancelButtonText: `Não`,
    });

    const excluir = resposta.isConfirmed;

    if (excluir) {
      try {
        setIsSaving(true);

        Swal.fire({
          icon: 'info',
          text: `Excluindo registro`,
          allowOutsideClick: false,
          showConfirmButton: false,
        });

        await api.delete(`/atividades/${registro.id}`);

        await buscarDados();

        toast.success('Feito!', {});
      } finally {
        setIsSaving(false);
        Swal.close();
      }
    }
  }

  return (
    <>
      <Header showCards={false} />
      {/* Page content */}
      <Container className="mt--7" fluid>
        <Row>
          <Col>
            <FormGroup className="mb-4">
              <InputGroup>
                <Button
                  className="btn-icon btn-2"
                  color="primary"
                  type="button"
                  onClick={handleOpenModal}
                >
                  <FaPlusCircle />
                </Button>
              </InputGroup>
            </FormGroup>
          </Col>
        </Row>

        {/* Table */}
        <Row>
          <div className="col">
            {/* Modal edição */}
            <Modal
              className="modal-dialog-centered"
              size="sm"
              isOpen={isModalOpen}
              toggle={() => setIsModalOpen(!isModalOpen)}
            >
              <div className="modal-body p-0">
                <Card className="bg-secondary shadow border-0">
                  <CardBody className="px-lg-5 py-lg-5">
                    <div className="text-center text-muted mb-4">
                      <small>Cadastro/Edição de Atividade</small>
                    </div>
                    <Form role="form">
                      <FormGroup className="mb-3">
                        <small>Código*</small>
                        <InputGroup className="input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-tag" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            placeholder="Código*"
                            value={registroEdicao.codigo}
                            type="text"
                            disabled={!registroEdicao.isNew}
                            onChange={text =>
                              setRegistroEdicao({
                                ...registroEdicao,
                                codigo: text.target.value,
                              })
                            }
                          />
                        </InputGroup>
                      </FormGroup>
                      <FormGroup className="mb-3">
                        <small>Descrição </small>
                        <InputGroup className="input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-tag" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            placeholder="Descrição*"
                            value={registroEdicao.descricao}
                            type="text"
                            onChange={text =>
                              setRegistroEdicao({
                                ...registroEdicao,
                                codigo: text.target.value,
                              })
                            }
                          />
                        </InputGroup>
                      </FormGroup>

                      <div className="text-center">
                        <Button
                          className="my-4"
                          color="primary"
                          type="button"
                          disabled={isSaving}
                          onClick={salvar}
                        >
                          Salvar
                        </Button>
                      </div>
                    </Form>
                  </CardBody>
                </Card>
              </div>
            </Modal>

            <Card className="shadow">
              <CardHeader className="border-0">
                <Row>
                  <Col sm="9">
                    <h3 className="mb-0">Lista de Atividade</h3>
                  </Col>
                </Row>
              </CardHeader>
              {loading ? (
                <Row>
                  <Col className="text-center mb-4 mt-4">
                    <CircularProgress />
                  </Col>
                </Row>
              ) : (
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th>Código</th>
                      <th>Descrição</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>
                    {registros.map((item: iAtividade) => {
                      return (
                        <tr key={item.id}>
                          <td className="py-2">{item.codigo}</td>
                          <td className="py-2">{item.descricao}</td>
                          <td className="py-2">
                            <div
                              className="float-right"
                              style={{
                                textAlign: 'right',
                              }}
                            >
                              <Button
                                className="btn-icon btn-2"
                                size="sm"
                                color="warning"
                                title="Editar registro"
                                type="button"
                                onClick={() => handleEdit(item)}
                              >
                                <FaEdit />
                              </Button>
                              <Button
                                className="btn-icon btn-2"
                                size="sm"
                                color="danger"
                                title="Remover registro"
                                type="button"
                                onClick={() => handleDelete(item)}
                              >
                                <FaTrash />
                              </Button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              )}
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
}
